// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._profile .ul-tabs.vs-tabs--ul.ul-tabs-left {\n  min-width: 15rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
